import { atom } from 'jotai';

export const siteDataAtom = atom([
  {
    SiteUID: 0,
    Pturb: 0,
    RPMMax: 0,
    DaykWh: 0,
    InvStatus: '',
    TurbineStatus: '', 
    HardwareStatus: '', 
    ShutdownStatus: '',
    Status: '',
    Vgrid: 0,
    Fgrid: 0,
    Vdc: 0,
    THIS: '',
    dbTimestamp: ''
  }
]);